
import TransactionMatchingTable, {
  type MatchGroup,
} from "./TransactionMatchingTable";

const sampleGroups: MatchGroup[] = [
  {
    key: "partiallyMatched",
    label: "Partially Matched",
    shown: 5,
    total: 22,
    rows: [
      {
        id: "1",
        date: "13 Sep 2026",
        receivedFrom: "Global Supplies",
        details: "Payment from customer",
        amount: 113789,
        suggestionRef: "INV-4322-0100",
        suggestionType: "Invoice",
        confidence: 76,
      },
      {
        id: "2",
        date: "13 Sep 2026",
        receivedFrom: "Global Supplies",
        details: "Payment from customer",
        amount: 113789,
        suggestionRef: "INV-4322-7552",
        suggestionType: "Pay Request",
        confidence: 75,
      },
      {
        id: "3",
        date: "22 Aug 2026",
        receivedFrom: "ABC STORE #1234",
        details: "Card Payment",
        amount: 153789,
        suggestionRef: "PR-2341-4244",
        suggestionType: "Invoice",
        confidence: 56,
      },
      {
        id: "4",
        date: "12 Aug 2026",
        receivedFrom: "ABC STORE #1234",
        details: "Direct Debit",
        amount: 3564,
        suggestionRef: "PR-2341-4244",
        suggestionType: "Direct Debit",
        confidence: 96,
      },
      {
        id: "5",
        date: "12 Jun 2025",
        receivedFrom: "ABC STORE #1234",
        details: "Invoice",
        amount: 459895,
        suggestionRef: "PR-2341-4457",
        suggestionType: "Invoice",
        confidence: 80,
      },
    ],
  },
  {
    key: "unmatched",
    label: "Unmatched",
    shown: 5,
    total: 11,
    rows: [
      {
        id: "6",
        date: "16 Sep 2026",
        receivedFrom: "ATM Cash Deposit 12345",
        details: "Cash Deposit",
        amount: 3789,
      },
      {
        id: "7",
        date: "13 Sep 2026",
        receivedFrom: "Bank Charge",
        details: "Service Charge",
        amount: 3216,
      },
      {
        id: "8",
        date: "12 Sep 2026",
        receivedFrom: "ABC STORE #1234",
        details: "Card Payment",
        amount: 789,
      },
      {
        id: "9",
        date: "12 Sep 2026",
        receivedFrom: "Global Supplies",
        details: "Payment from customer",
        amount: 789,
      },
      {
        id: "10",
        date: "12 Sep 2026",
        receivedFrom: "Al Ansari",
        details: "Service Charge",
        amount: 789,
      },
    ],
  },
  {
    key: "matched",
    label: "Matched",
    shown: 5,
    total: 12,
    rows: [
      {
        id: "11",
        date: "16 Sep 2026",
        receivedFrom: "Al Fardan",
        details: "FFY345678978 - Money Transfer",
        amount: 3789,
        suggestionRef: "INV-2024-0099",
        suggestionType: "Invoice",
      },
      {
        id: "12",
        date: "16 Sep 2026",
        receivedFrom: "Al Fardan",
        details: "FFY345678978 - Money Transfer",
        amount: 3789,
        suggestionRef: "INV-2024-0094",
        suggestionType: "Invoice",
      },
      {
        id: "13",
        date: "16 Sep 2026",
        receivedFrom: "Al Fardan",
        details: "FFY345678978 - Money Transfer",
        amount: 3789,
        suggestionRef: "INV-2024-7552",
        suggestionType: "Invoice",
      },
      {
        id: "14",
        date: "16 Sep 2026",
        receivedFrom: "Al Fardan",
        details: "FFY345678978 - Money Transfer",
        amount: 3789,
        suggestionRef: "INV-2024-7274",
        suggestionType: "Invoice",
      },
      {
        id: "15",
        date: "16 Sep 2026",
        receivedFrom: "Al Fardan",
        details: "FFY345678978 - Money Transfer",
        amount: 3789,
        suggestionRef: "INV-2024-0424",
        suggestionType: "Invoice",
      },
    ],
  },
  {
    key: "flaggedForInvestigation",
    label: "Flagged for Investigation",
    shown: 4,
    total: 4,
    rows: [
      {
        id: "16",
        date: "13 Sep 2026",
        receivedFrom: "Global Supplies",
        details: "Payment from customer",
        amount: 113789,
        suggestionRef: "INV-4322-7552",
        suggestionType: "Pay Request",
        confidence: 75,
      },
      {
        id: "17",
        date: "22 Aug 2026",
        receivedFrom: "ABC STORE #1234",
        details: "Card Payment",
        amount: 153789,
        suggestionRef: "PR-2341-4244",
        suggestionType: "Invoice",
        confidence: 56,
      },
      {
        id: "18",
        date: "12 Sep 2025",
        receivedFrom: "ABC STORE #1234",
        details: "Card Payment",
        amount: 789,
      },
      {
        id: "19",
        date: "12 Sep 2025",
        receivedFrom: "Global Supplies",
        details: "Payment from customer",
        amount: 789,
      },
    ],
  },
];

export const MatchedExample = () => {
  return (
    <TransactionMatchingTable
      groups={sampleGroups}
      onMatch={(row) => console.log("Match", row)}
      onSkip={(row) => console.log("Skip", row)}
      onFlag={(row) => console.log("Flag", row)}
      onUnflag={(row) => console.log("Unflag", row)}
      onViewDetails={(row) => console.log("View details", row)}
      onViewAll={(key) => console.log("View all", key)}
    />
  );
};